import { Sun, Cloud, CloudRain, CloudLightning, CloudSnow, Moon } from "lucide-react";

export const HERO_IMAGES = {
  clear: "https://images.unsplash.com/photo-1592698117601-70c282996f9c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  clouds: "https://images.unsplash.com/photo-1422466654108-5e533f591881?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  rain: "https://images.unsplash.com/photo-1561553873-e8491a564fd0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  storm: "https://images.unsplash.com/photo-1561553873-e8491a564fd0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  snow: "https://images.unsplash.com/photo-1478265409131-1f65c88f965c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  night: "https://images.unsplash.com/photo-1628498188904-036f5e25e93e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
};

export const CONDITION_LABEL = {
  clear: "Sereno",
  clouds: "Nuvoloso",
  rain: "Pioggia",
  storm: "Temporale",
  snow: "Neve",
  night: "Notte serena",
};

export const CONDITION_ICON = {
  clear: Sun,
  clouds: Cloud,
  rain: CloudRain,
  storm: CloudLightning,
  snow: CloudSnow,
  night: Moon,
};

export function windDirection(deg) {
  const dirs = ["N","NNE","NE","ENE","E","ESE","SE","SSE","S","SSO","SO","OSO","O","ONO","NO","NNO"];
  return dirs[Math.round(((deg % 360) / 22.5)) % 16];
}

const IT_TZ = "Europe/Rome";

export function formatDate(iso, opts) {
  try {
    return new Date(iso).toLocaleString("it-IT", {
      timeZone: IT_TZ,
      ...(opts ?? {
        day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
      }),
    });
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  return new Date(iso).toLocaleTimeString("it-IT", {
    timeZone: IT_TZ,
    hour: "2-digit",
    minute: "2-digit",
  });
}
